/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import React from "react";

/* global WorldWind */

export default class CopernicusCorineLandCover2018 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "CORINE Land Cover (2018)",
            service: "https://image.discomap.eea.europa.eu/arcgis/services/Corine/CLC2018_WM/MapServer/WMSServer?service=WMS",
            version: "1.3.0",
            layerNames: "12",
            size: 256,
            minActiveAltitude: 5e5,
        };

        super(cfg);

        this.urlBuilder.transparent = true;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© Copernicus Land Monitoring Service",
                WorldWind.Color.LIGHT_GRAY);
        }
    }


    getLayerDisplayInformation() {
        return (<div>
            <img
                src={"https://image.discomap.eea.europa.eu/arcgis/services/Corine/CLC2018_WM/MapServer/WmsServer?request=GetLegendGraphic&version=1.3.0&format=image/png&layer=12&"}
                alt={"Legend"}/>
        </div>);
    }
}
